import intl from 'react-intl-universal';
/**
 * 取件日期时间选择器
 */
import React, { useEffect, useState, MouseEvent } from 'react';
import { Tabs, Input, Popover } from 'antd';
import moment from 'moment';
import type { TabsProps } from 'antd';

import style from '../index.less';

interface Props {
    value: string;
    onChange: (value: string) => void;
    onSelect: (value: string, item: HourItem) => void;
    interval: number; //  间隔时间，默认2
    serviceDateList: {
        endTime: string;
        serviceDate: string;
        startTime: string;
    }[];
    company: string;
}

type HourItem = {
    date: string;
    text: string;
    startTime: number;
    endTime: number;
};
// type DateInfo = {
//     serviceDate: string;
//     startTime: string;
//     endTime: string;
// };

const DateTime: React.FC<Props> = (props) => {
    const {
        value,
        serviceDateList,
        interval = 2,
        onChange,
        onSelect,
        company,
    } = props;
    const [dateList, setDateList] = useState<string[]>([]);
    const [hourList, setHourList] = useState<HourItem[]>([]);
    const [showPop, setShowPop] = useState<boolean>(false);
    // const [jdDateList, setJDDateList] = useState<DateInfo[]>([]);
    const [selectDate, setSelectDate] = useState('');
    useEffect(() => {
        const documentClick = () => {
            setShowPop(false);
        };
        document.addEventListener('click', documentClick);

        return () => {
            document.removeEventListener('click', documentClick);
        };
    }, []);

    useEffect(() => {
        initData();
    }, [value, serviceDateList, company]);

    const initData = () => {
        const dateList = getDates(serviceDateList);
        setDateList(dateList);
        if (dateList?.length && !value) {
            onDateChange(dateList[0]);
        }
    };

    const onShowPop = (e: MouseEvent<HTMLInputElement>) => {
        e.target.blur?.();
        e.stopPropagation();
        selectDate && onDateChange(selectDate);
        setShowPop(true);
    };

    const onDateChange = (key: string) => {
        // const handleDate = company === 'JD' ? jdDateList : serviceDateList;
        let current: any = {};
        serviceDateList.forEach((item) => {
            if (item.serviceDate === key) {
                current = item;
            }
        });
        setSelectDate(key);
        const { serviceDate, startTime, endTime } = current || {};
        setHourList(getHours(serviceDate, startTime, endTime, interval));
    };
    const getNowHour = () => {
        const nowTime = moment();
        let nowHour = nowTime.hour();
        const nowMinute = nowTime.minute();
        // if (company === 'JD') {
        //     // 分钟大于1，小时加2
        //     nowHour = nowMinute >= 1 ? nowHour + 2 : nowHour;
        //     return nowHour;
        // } else if (company === 'SF') {
        //     nowHour = nowMinute >= 1 ? nowHour + 1 : nowHour;
        //     return nowHour;
        // }
        nowHour = nowMinute >= 1 ? nowHour + 1 : nowHour;
        return nowHour;
    };

    const todayValid = () => {
        const nowHour = getNowHour();
        // return company === 'JD'
        //     ? nowHour < 18
        //     : nowHour < moment(serviceDateList[0].endTime).hour();
        return nowHour < moment(serviceDateList[0].endTime).hour();
    };

    const getDates = (dates: any[]) => {
        // if (company === 'JD') {
        //     let nowTimeMill = moment().format('YYYY-MM-DD');
        //     if (!todayValid()) {
        //         nowTimeMill = moment().add(1, 'day').format('YYYY-MM-DD');
        //     }
        //     const dateList = [];
        //     const dateTimeList = [];
        //     // 仅展示三天的选择时间
        //     for (let i = 0; i < 3; i++) {
        //         const newTime = moment(nowTimeMill)
        //             .add(i, 'day')
        //             .format('YYYY-MM-DD');
        //         dateList.push(newTime);
        //         dateTimeList.push({
        //             serviceDate: newTime,
        //             startTime: `${newTime} 08:00:00`,
        //             endTime: `${newTime} 18:00:00`,
        //         });
        //     }
        //     setJDDateList(dateTimeList);
        //     return dateList;
        // } else if (company === 'SF') {
        return dates
            .map((item) => {
                if (isToday(item.serviceDate) && !todayValid()) {
                    return false;
                } else {
                    return item.serviceDate;
                }
            })
            .filter((item) => !!item);
        // }
    };

    const isToday = (date: string) => {
        return moment().dayOfYear() === moment(date).dayOfYear();
    };

    const getHours = (
        serviceDate: string = '',
        startTime: string = '',
        endTime: string = '',
        distance = interval,
    ) => {
        const now = moment();
        let startHour = moment(startTime).hour();
        let endHour = moment(endTime).hour();
        if (isToday(serviceDate)) {
            startHour = now.hour() < startHour ? startHour : getNowHour();
        }
        // if (company === 'JD') {
        //     if (todayValid() && !index) {
        //         startHour = now.hour() < 8 ? 8 : getNowHour();
        //     } else {
        //         startHour = 8;
        //     }
        // }
        const hourList: HourItem[] = [];
        let timeCount = Math.ceil((endHour - startHour) / distance);
        for (let i = 0; i < timeCount; i++) {
            hourList.push({
                date: serviceDate,
                text: `${startHour}:00-${
                    startHour + distance > endHour
                        ? endHour
                        : startHour + distance
                }:00`,

                startTime: startHour,
                endTime:
                    startHour + distance > endHour
                        ? endHour
                        : startHour + distance,
            });
            startHour += distance;
        }
        return hourList;
    };

    const onSelectTime = (value: HourItem) => {
        onChange?.(
            `${value?.date} ${value?.startTime}:00 - ${value?.endTime}:00`,
        );
        onSelect?.(
            `${value?.date} ${value?.startTime}:00 - ${value?.endTime}:00`,
            value,
        );
        setSelectDate(value?.date);
        setShowPop(false);
    };

    const items: TabsProps['items'] = dateList?.map((date) => {
        return {
            key: date,
            label: date,
            children: (
                <ul className={style.hourList}>
                    {hourList.map((item) => (
                        <li
                            key={item.text}
                            onClick={() => onSelectTime(item)}
                        >
                            {item.text}
                        </li>
                    ))}
                </ul>
            ),
        };
    });

    const handlerPopClick = (e) => {
        e.nativeEvent.stopPropagation();
    };

    return (
        <Popover
            open={showPop}
            trigger="click"
            placement="topLeft"
            content={
                dateList?.length ? (
                    <Tabs
                        activeKey={selectDate}
                        onClick={handlerPopClick}
                        className="popover-select-time-tab"
                        size="small"
                        onChange={onDateChange}
                        tabPosition="left"
                        destroyInactiveTabPane={true}
                        items={items}
                    ></Tabs>
                ) : (
                    <span>
                        {intl.get('当前地址暂不支持上门取件，请选择自行寄回')}
                    </span>
                )
            }
        >
            <Input
                value={value}
                onClick={onShowPop}
                placeholder={intl.get('请选择上门取件时间')}
                disabled={!dateList?.length}
            ></Input>
        </Popover>
    );
};

export default DateTime;
